import PageError from "../../app/PageError.jsx";
import { BinIcon } from "../../components/icon/Icon.jsx";
import { LANG_CHOOSER_TYPES, LangChooser } from '../../modules/LangChooser';
import _ from "lodash";
import { useResponsive } from '../../components/responsive';
import { ContactsIconContainerStyled } from "./styled/ContactsStyled.js";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

export const Contacts = () => {
    const {getLangPath} = useLangContext();
    const {isMediumMaxWidth, isSmallMaxWidth} = useResponsive();
    return (
            <PageError
                    iconComponent={
                        <ContactsIconContainerStyled className="mb-3">
                            <BinIcon name="IcQuestionMarkBubble" style={{fontSize: '48px', fill: '#14C679'}}/>
                        </ContactsIconContainerStyled>
                    }
                    headerText={_.capitalize(getLangPath('promo.fx.footer.contacts'))}
                    headerPanelComponent={
                        <LangChooser
                                type={isMediumMaxWidth ? LANG_CHOOSER_TYPES.slider : LANG_CHOOSER_TYPES.dropdown}
                                isHideButtonArrowIcon={isMediumMaxWidth}
                                isHideButtonName={isSmallMaxWidth}
                        />
                    }
            >
                <div>
                    {getLangPath('forms.label.email')}:{' '}
                    <a href="mailto:support@fx.binomo.com" style={{color: 'var(--color-white)'}}>
                        support@fx.binomo.com
                    </a>
                </div>
            </PageError>
    )
}
